import React from 'react';
import StatusCards from '../components/StatusCards';
import logoAyuntamiento from '../assets/img/logo_ayuntamiento.png';

function HomePage() {
  return (
    <div>
        <div className="logo-ayuntamiento">
            <img src={logoAyuntamiento} alt="Logo del Ayuntamiento de Madrid" style={{ cursor: 'pointer' }} />
        </div>
      <StatusCards></StatusCards>
    </div>
  );
}

export default HomePage;
